import script from "./CustomDialogueModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomDialogueModal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomDialogueModal.vue?vue&type=style&index=0&id=114a4372&scoped=true&lang=scss"
import "@/styles/dialogue-modal.css?vue&type=style&index=1&id=114a4372&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-114a4372"]])

export default __exports__